// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	AddButton: 'add-button',
	PurchaseButton: 'purchase-button',
	PurchaseSelectedButton: 'purchase-selected-button',
	DebtButton: 'debt-button',
	ViewDebtButton: 'view-debt-button',
	ReqButton: 'req-button',
	ViewReqButton: 'view-req-button',
	ToggleSelectWritCheckbox: 'toggle-select-writ-checkbox',
	SelectAllCheckbox: 'select-all-checkbox',
	Input1: 'input-1',
	ClickWritDiv: 'click-writ-div',
	ClickWritSearchDiv: 'click-writ-search-div',
	ShowSelectedCertificateDiv: 'show-selected-certificate-div',
	WritPurchaseInProgressIcon: 'writ-purchase-in-progress-icon',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
